import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  ConsultaPublica,
  NovaParticipacao,
  Sugestao,
  VerificacaoParticipacao,
} from '../interfaces/public-consultation';

@Injectable({ providedIn: 'root' })
export class PublicConsultationService {
  private readonly baseUrl = environment.api;

  constructor(private readonly http: HttpClient) {}

  listarConsultasAbertas(): Observable<ConsultaPublica[]> {
    return this.http.get<ConsultaPublica[]>(
      `${this.baseUrl}/consultas-publicas/abertas`,
    );
  }

  verificarParticipacao(
    cpf: string,
    consultaId: number,
  ): Observable<VerificacaoParticipacao> {
    return this.http.post<VerificacaoParticipacao>(
      `${this.baseUrl}/participacoes/verificar`,
      { cpf, consultaId },
    );
  }

  enviarParticipacao(payload: NovaParticipacao): Observable<Sugestao> {
    return this.http.post<Sugestao>(`${this.baseUrl}/participacoes`, payload);
  }
}
